var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.pageTitle,
      "icon": "pe-7s-note2"
    },
    scopedSlots: _vm._u([_vm.$store.getters.getFrontendParameterValue('process-products-sort', 'page-title-show-location-and-batch') ? {
      key: "subTitle",
      fn: function () {
        return [_c('location-link', {
          attrs: {
            "location": _vm.location,
            "hide-arrow": ""
          }
        }), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.pageSubTitle)
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), !_vm.isSortingZoneSelected ? _c('b-row', [_c('b-col', [_c('b-card', [_c('b-card-title', [_vm._v("SCAN ZONE")]), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    ref: "sortingZoneIdentifierInput",
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Sorteerzone",
      "required": "",
      "autofocus": "",
      "autocomplete": "off"
    },
    model: {
      value: _vm.sortingZoneIdentifierInput,
      callback: function ($$v) {
        _vm.sortingZoneIdentifierInput = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "sortingZoneIdentifierInput"
    }
  }), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v("Kies")])], 1)], 1)], 1)], 1) : _c(_vm.PROCESS_COMPONENTS[_vm.processType], {
    tag: "component",
    attrs: {
      "location": _vm.location,
      "batchModelType": _vm.batchModelType,
      "batchModelIdentifier": _vm.batchModelIdentifier,
      "storageZoneIdentifier": _vm.sortingZoneIdentifierInput,
      "processType": _vm.processType
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }